export const MAX_WORKPLACE_WIDTH = 568
